import { create } from 'zustand';
import { Dayjs } from 'dayjs';
import { SingleTicketResponse } from '@/types';
import { NormalizedTicketStatus } from '@/utils/ticketStatus';

export enum TicketSearchByEnum {
  PLATFORM_CODE = 'platformCode',
  TICKET_ID = 'ticketId',
  CUSTOM_ID = 'customId',
  FILTERS = 'filters',
}

export enum TicketSortByEnum {
  CREATED_AT = 'created_at',
  UPDATED_AT = 'updated_at',
}
export enum TicketSortOrderEnum {
  DESC = 'desc',
  ASC = 'asc',
}

export enum TicketSortKeyEnum {
  CREATED_DESC = 'CREATED_DESC',
  CREATED_ASC = 'CREATED_ASC',
  UPDATED_DESC = 'UPDATED_DESC',
  UPDATED_ASC = 'UPDATED_ASC',
}

export interface ISearchTicket {
  searchText?: string;
  searchBy?: TicketSearchByEnum;
}
export interface TicketFilters extends ISearchTicket {
  statusFilter: string[];
  createdAtFilter?: [Dayjs, Dayjs];
}
export interface Ticketing extends TicketFilters {
  isModalOpen: boolean;
  ticketFormData?: SingleTicketResponse;
  sortKey: TicketSortKeyEnum;
}

interface StoreAndActions extends Ticketing {
  //filter
  setStatus: (value: NormalizedTicketStatus[]) => void;
  setCreatedAt: (value?: [Dayjs, Dayjs]) => void;
  resetFilers: () => void;
  //search
  setSearchData: (value?: ISearchTicket) => void;
  //other
  openModal: () => void;
  closeModal: () => void;
  setTicketFormData: (value?: SingleTicketResponse) => void;
  setSortKey: (key: TicketSortKeyEnum) => void;
}

const useTicketingStore = create<StoreAndActions>((set, get) => ({
  isModalOpen: false,
  sortKey: TicketSortKeyEnum.CREATED_DESC,
  sortBy: TicketSortByEnum.CREATED_AT,
  openModal: () => set({ isModalOpen: true }),
  closeModal: () => set({ isModalOpen: false, ticketFormData: undefined }),
  setSortKey: (key) => set({ sortKey: key }),
  ticketFormData: undefined,
  setTicketFormData: (value) => set({ ticketFormData: value }),

  //_______________________ Filtering List
  statusFilter: [],
  createdAtFilter: undefined,
  setStatus: (value) => set({ statusFilter: value }),
  setCreatedAt: (value) => set({ createdAtFilter: value }),
  resetFilers: () => {
    set({
      createdAtFilter: undefined,
      statusFilter: [],
    });
  },
  resetSearch: () => {
    set({
      searchBy: undefined,
      searchText: undefined,
    });
  },

  //_______________________ Searching List
  searchBy: undefined,
  searchText: undefined,
  setSearchData: (value) => set({ searchBy: value?.searchBy, searchText: value?.searchText }),
}));

export default useTicketingStore;
